import template from './multiple-select.html';
import controller from './multiple-select.controller';

const MultipleSelectComponent = {
  template,
  controller,
  bindings: {
    options: '<',
    selectedValues: '=',
    onSelect: '&',
    placeholder: '@',
    idKey: '@',
    complexSel: '@',
    labelKey: '@',
    imgKey: '@',
    mode: '@',
    disabled: '<',
    required: '<',
  },
};

export default MultipleSelectComponent;



// WEBPACK FOOTER //
// ../widgets/multiple-select/multiple-select.component.js